import type { PropsWithChildren } from 'react'
import React from 'react'
import Typography from '../Typography/Typography'

function Banner({
  children,
}: PropsWithChildren<Record<string, unknown>>): JSX.Element {
  return (
    <div
      className="bg-primary-10 w-full px-4.5 py-2.5 inline-flex items-center flex-grow flex-wrap"
      role="banner"
    >
      {children}
    </div>
  )
}

function Content({
  children,
}: PropsWithChildren<Record<string, unknown>>): JSX.Element {
  return <div className="flex items-center text-inherit">{children}</div>
}

function StartAdornment({
  children,
}: PropsWithChildren<Record<string, unknown>>): JSX.Element {
  return (
    <span className="flex-shrink-0 w-6 h-6 mr-2.5 text-primary-main">
      {children}
    </span>
  )
}

function Description({
  children,
}: PropsWithChildren<Record<string, unknown>>): JSX.Element {
  return (
    <Typography color="inherit" variant="body2">
      {children}
    </Typography>
  )
}

function Actions({
  children,
}: PropsWithChildren<Record<string, unknown>>): JSX.Element {
  return (
    <div className="ml-3">
      <div className="flex space-x-3">{children}</div>
    </div>
  )
}

Banner.Actions = Actions
Banner.Content = Content
Banner.Description = Description
Banner.StartAdornment = StartAdornment

Banner.displayName = 'Banner'

// Proper display names are necessary to generate correct code snippets in stories
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
Banner.Actions.displayName = 'Banner.Actions'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
Banner.Content.displayName = 'Banner.Content'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
Banner.Description.displayName = 'Banner.Description'
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
Banner.StartAdornment.displayName = 'Banner.StartAdornment'

export default Banner
